import { useQuery } from "@tanstack/react-query";
import { createFileRoute, Link } from "@tanstack/react-router";

import {
  ContactIcon,
  EvaluationIcon,
  OpportunityIcon,
  OrganizationIcon,
  RequirementSetIcon,
  UsersIcon,
} from "~/components/admin/Icons";

import { RecentContacts } from "~/components/admin/RecentContacts";
import { RecentOpportunities } from "~/components/admin/RecentOpportunities";
import { StatCard } from "~/components/admin/StatCard";
import { useTRPC } from "~/lib/trpc";

export const Route = createFileRoute("/_authenticated/admin/")({
  component: DashboardPage,
});

function DashboardPage() {
  const trpc = useTRPC();

  const organizationsCount = useQuery(
    trpc.salesforce.organizations.count.queryOptions(undefined, {
      trpc: { context: { skipBatch: true } },
    }),
  );

  const usersCount = useQuery(
    trpc.users.count.queryOptions(undefined, {
      trpc: { context: { skipBatch: true } },
    }),
  );

  const opportunitiesCount = useQuery(
    trpc.opportunities.count.queryOptions(undefined, {
      trpc: { context: { skipBatch: true } },
    }),
  );

  const contactsCount = useQuery(
    trpc.contacts.count.queryOptions(undefined, {
      trpc: { context: { skipBatch: true } },
    }),
  );

  const requirementSetsCount = useQuery(
    trpc.opportunities.requirements.count.queryOptions(undefined, {
      trpc: { context: { skipBatch: true } },
    }),
  );

  const evaluationsCount = useQuery(
    trpc.contacts.evaluations.count.queryOptions(undefined, {
      trpc: { context: { skipBatch: true } },
    }),
  );

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3">
        <Link to="/admin/organizations" className="contents">
          <StatCard
            label="Organizations"
            icon={<OrganizationIcon className="h-7 w-7" />}
            value={organizationsCount.data ?? 0}
            isLoading={organizationsCount.isLoading}
            error={organizationsCount.error}
            clickable
          />
        </Link>
        <Link to="/admin/users" className="contents">
          <StatCard
            label="Users"
            icon={<UsersIcon className="h-7 w-7" />}
            value={usersCount.data ?? 0}
            isLoading={usersCount.isLoading}
            error={usersCount.error}
            clickable
          />
        </Link>
        <StatCard
          label="Opportunities"
          icon={<OpportunityIcon className="h-7 w-7" />}
          value={opportunitiesCount.data ?? 0}
          isLoading={opportunitiesCount.isLoading}
          error={opportunitiesCount.error}
        />
        <StatCard
          label="Contacts"
          icon={<ContactIcon className="h-7 w-7" />}
          value={contactsCount.data ?? 0}
          isLoading={contactsCount.isLoading}
          error={contactsCount.error}
        />
        <StatCard
          label="Requirement Sets"
          icon={<RequirementSetIcon className="h-7 w-7" />}
          value={requirementSetsCount.data ?? 0}
          isLoading={requirementSetsCount.isLoading}
          error={requirementSetsCount.error}
        />
        <StatCard
          label="Evaluations"
          icon={<EvaluationIcon className="h-7 w-7" />}
          value={evaluationsCount.data ?? 0}
          isLoading={evaluationsCount.isLoading}
          error={evaluationsCount.error}
        />
      </div>

      <div className="grid grid-cols-1 gap-6 xl:grid-cols-2">
        <RecentOpportunities limit={5} />
        <RecentContacts limit={5} />
      </div>
    </div>
  );
}
